import { GlobalResponseObject } from '@gtpl/shared-models/common-models';


export class ResourceOperationEfficiencyStatusWiseResponseModel extends GlobalResponseObject {
    active?: number;
    inActive?: number;
    total?: number;
}
